import { CSSProperties } from 'react'

import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const Dados = styled.div`
  margin-top: 25px;
  overflow-x: auto;

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #f5f5f5;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.2);
  }
`

/** Cards de topo do Nível 1 (contagem por estado). */
export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
`

export const Card = styled.div<{ corTopo: string }>`
  background: ${Cores.BRANCO};
  border-radius: 8px;
  padding: 18px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid ${Cores.CINZA_3_CLARO};
  border-top: 3px solid ${({ corTopo }) => corTopo};
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const CardNumero = styled.span<{ cor: string }>`
  font-size: 30px;
  font-weight: 300;
  line-height: 1;
  color: ${({ cor }) => cor};
`

export const CardRotulo = styled.span`
  font-size: 12px;
  color: ${Cores.CINZA_2};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 6px;
`

export const CardPonto = styled.span<{ cor: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  background: ${({ cor }) => cor};
`

/** Barra de ações (título + filtros) acima da tabela. */
export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 10px;
`

export const ToolbarTitulo = styled.div`
  font-family: 'Saira', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: ${Cores.PRETO};
`

export const ToolbarAcoes = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const Select = styled.select`
  font-family: 'Roboto', sans-serif;
  border-radius: 3px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid ${Cores.CINZA_3_CLARO};
  background: ${Cores.BRANCO};
  color: ${Cores.CINZA_2};
  padding: 9px 12px;
`

export const CampoBusca = styled.input`
  font-family: 'Roboto', sans-serif;
  border-radius: 3px;
  font-size: 13px;
  border: 1px solid ${Cores.CINZA_3_CLARO};
  background: ${Cores.BRANCO};
  color: ${Cores.CINZA_1};
  padding: 9px 12px;
  width: 200px;

  ::placeholder {
    color: ${Cores.CINZA_2_CLARO};
  }
`

/** Nome do serviço/aluno + dica/erro na 2ª linha (sem linha expansível nativa). */
export const NomeCelula = styled.span`
  font-weight: 500;
  color: ${Cores.CINZA_1};
  display: block;
`

export const SubCelula = styled.span<{ tipo?: 'erro' | 'alerta' }>`
  display: block;
  font-size: 11px;
  margin-top: 3px;
  color: ${({ tipo }) =>
    tipo === 'erro'
      ? Cores.PERIGO_ERRO
      : tipo === 'alerta'
      ? Cores.ATENCAO_ESCURO
      : Cores.CINZA_2_CLARO};
`

export const LinkCelula = styled.span`
  color: ${Cores.SECUNDARIA_1_ESCURO};
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }
`

/** Botão de ícone "olho" inline na 1ª coluna (abrir parcelas). */
export const BotaoOlho = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-right: 8px;
  border: 0;
  background: transparent;
  cursor: pointer;
  vertical-align: middle;

  svg {
    width: 16px;
    height: auto;
  }

  svg path {
    fill: ${Cores.CINZA_2};
    transition: fill 0.1s;
  }

  :hover svg path {
    fill: ${Cores.SECUNDARIA_1_ESCURO};
  }
`

/** Nome + ícone "?" alinhados; o tooltip dispara só no ícone. */
export const NomeComAjuda = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

export const IconeAjuda = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid ${Cores.CINZA_2_CLARO};
  color: ${Cores.CINZA_2};
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  cursor: help;
  flex-shrink: 0;

  :hover {
    border-color: ${Cores.SECUNDARIA_1_ESCURO};
    color: ${Cores.SECUNDARIA_1_ESCURO};
  }
`

/** Cabeçalho-resumo da execução (Nível 3). */
export const ResumoExecucao = styled.div`
  background: ${Cores.BRANCO};
  border: 1px solid ${Cores.CINZA_3_CLARO};
  border-radius: 8px;
  padding: 14px 18px;
  margin-bottom: 16px;
  display: flex;
  gap: 28px;
  flex-wrap: wrap;
`

export const ResumoItem = styled.div`
  .chave {
    font-size: 11px;
    color: ${Cores.CINZA_2_CLARO};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .valor {
    font-size: 16px;
    font-family: 'Saira', sans-serif;
    font-weight: 600;
    color: ${Cores.CINZA_1};
    margin-top: 2px;
  }
`

/**
 * Largura mínima + nowrap para colunas numéricas estreitas (Encontr./Proc./
 * ✓/✗/⤼/Duração), evitando que o cabeçalho quebre em várias linhas.
 */
export const colunaNumericaStyle: CSSProperties = {
  minWidth: 64,
  whiteSpace: 'nowrap'
}

export const colunaDuracaoStyle: CSSProperties = {
  minWidth: 80,
  whiteSpace: 'nowrap'
}

/** Colunas de contador de uma só caractere no header (✓/✗/⤼). */
export const colunaIconeStyle: CSSProperties = {
  minWidth: 44,
  whiteSpace: 'nowrap'
}

/** Aviso (caso Suspect / período sem dados). */
export const Aviso = styled.div`
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${Cores.ATENCAO_FUNDO};
  border-left: 3px solid ${Cores.ATENCAO};
  color: ${Cores.ATENCAO_ESCURO};
  font-size: 12px;
  line-height: 1.5;
`
